import './Services.css';
import './ServiceDetails.css';
import './HomePreview.css';
import './ServicesPath.css';
import { servicesData } from '../data/servicesData';

// The 5 core service lines shown on the homepage — the granular sub-services
// (SEO, Google Ads, Meta Ads, Social Media Management, Shopify eCommerce)
// live inside their parent's detail page and the full /services explorer.
const coreSlugs = [
  'website-development',
  'digital-marketing',
  'graphic-design',
  'ai-solutions',
  'custom-software-development',
];

// Each core service gets its own pastel card colour + bead colour, cycling
// through a small on-brand palette so the path reads as one connected trail.
const PALETTE = [
  { bead: '#f2703c', bg: '#fdece0', num: '#e85a2a' },   // peach / orange
  { bead: '#e63f8c', bg: '#fbe7ef', num: '#d62f79' },   // pink
  { bead: '#8a5cf6', bg: '#efeafd', num: '#7440e0' },   // lavender
  { bead: '#e2a300', bg: '#fdf6df', num: '#c98d00' },   // amber
  { bead: '#1f9d7c', bg: '#e6f7f0', num: '#178066' },   // mint / brand green
];

const ROW_H = 250; // px — assumed vertical spacing per card, keeps the SVG trail in sync

export default function ServicesPreview() {
  const items = coreSlugs.map(slug => servicesData.find(s => s.slug === slug)).filter(Boolean);
  const total = items.length;

  // Build a smooth zig-zag bezier trail behind the cards: left card centre
  // at x=150, right card centre at x=850 (in a 0–1000 viewBox).
  const pathD = items.map((_, i) => {
    const x = i % 2 === 0 ? 150 : 850;
    const y = i * ROW_H;
    if (i === 0) return `M${x},${y}`;
    const prevX = (i - 1) % 2 === 0 ? 150 : 850;
    const prevY = (i - 1) * ROW_H;
    const midY = (prevY + y) / 2;
    return `C${prevX},${midY} ${x},${midY} ${x},${y}`;
  }).join(' ');

  return (
    <section id="services-preview" className="services-section">
      <div className="services-header reveal">
        <span className="section-label">What We Do</span>
        <h2 className="section-title">Full-stack digital growth. <em>Every layer covered.</em></h2>
        <p className="section-sub">From storefront to storefeed, from first click to last mile — one team, one timeline, one accountable partner.</p>
      </div>

      <div className="svc-path" style={{ height: `${(total - 1) * ROW_H + 220}px` }}>
        <svg
          className="svc-path-line"
          viewBox={`0 0 1000 ${(total - 1) * ROW_H + 220}`}
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="svcPathGrad" x1="0" y1="0" x2="0" y2="1">
              {PALETTE.map((p, i) => (
                <stop key={i} offset={`${(i / (PALETTE.length - 1)) * 100}%`} stopColor={p.bead} />
              ))}
            </linearGradient>
          </defs>
          <path d={pathD} fill="none" stroke="url(#svcPathGrad)" strokeWidth="3" strokeDasharray="2 14" strokeLinecap="round" />
        </svg>

        {items.map((s, i) => {
          const c = PALETTE[i % PALETTE.length];
          const side = i % 2 === 0 ? 'left' : 'right';
          return (
            <a
              key={s.slug}
              href={`#/services/${s.slug}`}
              className={`svc-path-row reveal ${side}`}
              style={{ top: `${i * ROW_H}px` }}
            >
              <span className="svc-path-bead" style={{ background: c.bead, boxShadow: `0 0 22px ${c.bead}99` }} />
              <div className="svc-path-card" style={{ background: c.bg }}>
                <span className="svc-path-num" style={{ color: c.num }}>{String(i + 1).padStart(2, '0')}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <span className="svc-path-explore">EXPLORE SERVICE →</span>
              </div>
            </a>
          );
        })}
      </div>

      <div className="home-more reveal">
        <a href="#/services" className="btn-ghost">View All Services →</a>
      </div>
    </section>
  );
}
